import React, { useState, useRef, useEffect } from 'react';
import { FiPrinter } from 'react-icons/fi';

const PrintOptions = ({ onPrintOptionSelected }) => {
  const [showOptions, setShowOptions] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    function handleClickOutside(event) {
      if (containerRef.current && !containerRef.current.contains(event.target)) {
        setShowOptions(false);
      }
    }
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const toggleOptions = () => {
    setShowOptions((prev) => !prev);
  };

  const handleOptionClick = (option) => {
    onPrintOptionSelected(option);
    setShowOptions(false);
  };

  return (
    <div ref={containerRef} className="relative inline-block text-left">
      <button
        onClick={toggleOptions}
        className="flex items-center gap-2 bg-green-600 text-white px-3 py-1.5 rounded-md shadow hover:bg-green-700 transition text-sm"
      >
        <FiPrinter size={16} />
        <span className="font-medium">Cetak</span>
      </button>

      {showOptions && (
        <div className="absolute right-0 z-10 w-48 mt-2 overflow-hidden bg-white border border-gray-200 rounded-md shadow-lg">
          <button
            onClick={() => handleOptionClick('invoice')}
            className="w-full px-4 py-2 text-sm text-left transition hover:bg-green-50 hover:text-green-700"
          >
            📄 Invoice
          </button>
          <button
            onClick={() => handleOptionClick('serahTerimaInvoice')}
            className="w-full px-4 py-2 text-sm text-left transition hover:bg-yellow-50 hover:text-yellow-700"
          >
            🧾 Serah Terima Invoice
          </button>
          <button
            onClick={() => handleOptionClick('serahTerimaNota')}
            className="w-full px-4 py-2 text-sm text-left transition hover:bg-red-50 hover:text-red-700"
          >
            📃 Serah Terima Nota
          </button>
        </div>
      )}
    </div>
  );
};

export default PrintOptions;
